import createFromViewState from './createFromViewState';
import { getSentToAddress } from './getFromAddresses';
import { FromViewState } from 'owa-mail-compose-store';
import shouldAlwaysShowFrom from '../utils/shouldAlwaysShowFrom';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import ItemId from 'owa-service/lib/contract/ItemId';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function getFromViewState(
    from: EmailAddressWrapper,
    meetingRequestItem: Partial<MeetingRequestMessageType>,
    referenceItemId: ItemId,
    isPost?: boolean,
    isFromShownInViewState: boolean = true
): FromViewState {
    // If it's a meeting request, the meeting is owned by a specific user, so we can't allow it to change.
    const isFromReadOnly = !!meetingRequestItem;

    const isFromShown =
        (shouldAlwaysShowFrom() || from != null) && !isFromReadOnly && isFromShownInViewState;

    let defaultFrom: EmailAddressWrapper = null;
    if (!from) {
        const sentToAddress = getSentToAddress(referenceItemId);
        if (sentToAddress) {
            defaultFrom = <EmailAddressWrapper>{
                MailboxType: 'Mailbox',
                RoutingType: 'SMTP',
                EmailAddress: sentToAddress,
                Name: getUserConfiguration().SessionSettings.UserDisplayName,
            };
        }
    }

    return createFromViewState(isFromShown, from ? from : defaultFrom, isFromReadOnly, isPost);
}
